const atestado_de_eliminacao = [
  {
    path: "/atestado-de-eliminacao",
    redirect: "/atestado_de_eliminacao",
    meta: {
      breadCrumb: "Gestão - Emissão de Documentos",
    },
    children: [
      {
        path: "/atestado-de-eliminacao",
        name: "atestado_de_eliminacao",
        component: () =>
          import("@/views/AtestadoDeEliminacao/AtestadoDeEliminacao.vue"),
      },
    ],
  },
];

export { atestado_de_eliminacao };
